[
  {
    "id": "basic_0001",
    "requirement": 15,
    "reward": {
      "type": "energy",
      "duration": 900000
    }
  },
  {
    "id": "basic_0002",
    "requirement": 55,
    "reward": {
      "type": "powerups_combo",
      "subType": "lollipop_firecracker",
      "amount": 1
    }
  },
  {
    "id": "basic_0003",
    "requirement": 125,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "amount": 1
    }
  },
  {
    "id": "basic_0004",
    "requirement": 255,
    "reward": {
      "type": "gems",
      "amount": 60
    }
  },
  {
    "id": "basic_0005",
    "requirement": 305,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "basic_0006",
    "requirement": 355,
    "reward": {
      "type": "powerups_combo",
      "subType": "firecracker_balloon",
      "amount": 1
    }
  },
  {
    "id": "basic_0007",
    "requirement": 515,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_1",
      "amount": 1
    }
  },
  {
    "id": "basic_0008",
    "requirement": 655,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "amount": 1
    }
  },
  {
    "id": "basic_0009",
    "requirement": 745,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_2",
      "amount": 2
    }
  },
  {
    "id": "basic_0010",
    "requirement": 955,
    "reward": {
      "type": "gems",
      "amount": 100
    }
  },
  {
    "id": "basic_0011",
    "requirement": 1015,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "basic_0012",
    "requirement": 1075,
    "reward": {
      "type": "boosters",
      "subType": "bullet",
      "amount": 1
    }
  },
  {
    "id": "basic_0013",
    "requirement": 1275,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "amount": 3
    }
  },
  {
    "id": "basic_0014",
    "requirement": 1375,
    "reward": {
      "type": "multiplier",
      "subType": 2,
      "duration": 900000
    }
  },
  {
    "id": "basic_0015",
    "requirement": 1575,
    "reward": {
      "type": "gems",
      "amount": 100
    }
  },
  {
    "id": "basic_0016",
    "requirement": 1725,
    "reward": {
      "type": "powerups",
      "subType": "rocket",
      "duration": 900000
    }
  },
  {
    "id": "basic_0017",
    "requirement": 1775,
    "reward": {
      "type": "powerups_combo",
      "subType": "lollipop_firecracker",
      "amount": 1
    }
  },
  {
    "id": "basic_0018",
    "requirement": 1975,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "amount": 1
    }
  },
  {
    "id": "basic_0019",
    "requirement": 2375,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_3",
      "amount": 1
    }
  },
  {
    "id": "basic_0020",
    "requirement": 2475,
    "reward": {
      "type": "powerups",
      "subType": "bomb",
      "amount": 3
    }
  },
  {
    "id": "basic_0021",
    "requirement": 2625,
    "reward": {
      "type": "multiplier",
      "subType": 2,
      "duration": 1800000
    }
  },
  {
    "id": "basic_0022",
    "requirement": 2925,
    "reward": {
      "type": "gems",
      "amount": 100
    }
  },
  {
    "id": "basic_0023",
    "requirement": 3025,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "basic_0024",
    "requirement": 3175,
    "reward": {
      "type": "powerups",
      "subType": "bomb",
      "duration": 900000
    }
  },
  {
    "id": "basic_0025",
    "requirement": 3275,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "amount": 3
    }
  },
  {
    "id": "basic_0026",
    "requirement": 3425,
    "reward": {
      "type": "multiplier",
      "subType": 2,
      "duration": 900000
    }
  },
  {
    "id": "basic_0027",
    "requirement": 3825,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_1",
      "amount": 1
    }
  },
  {
    "id": "basic_0028",
    "requirement": 4325,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "amount": 1
    }
  },
  {
    "id": "basic_0029",
    "requirement": 4425,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "basic_0030",
    "requirement": 4625,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "duration": 1800000
    }
  },
  {
    "id": "basic_0031",
    "requirement": 5125,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_1",
      "amount": 1
    }
  },
  {
    "id": "basic_0032",
    "requirement": 5725,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "amount": 3
    }
  },
  {
    "id": "basic_0033",
    "requirement": 5825,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "basic_0034",
    "requirement": 6025,
    "reward": {
      "type": "powerups",
      "subType": "rocket",
      "duration": 900000
    }
  },
  {
    "id": "basic_0035",
    "requirement": 6525,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_3",
      "amount": 1
    }
  },
  {
    "id": "basic_0036",
    "requirement": 6625,
    "reward": {
      "type": "gems",
      "amount": 100
    }
  },
  {
    "id": "basic_0037",
    "requirement": 6825,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "basic_0038",
    "requirement": 7325,
    "reward": {
      "type": "powerups",
      "subType": "bomb",
      "duration": 900000
    }
  },
  {
    "id": "basic_0039",
    "requirement": 7925,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "amount": 3
    }
  },
  {
    "id": "basic_0040",
    "requirement": 8025,
    "reward": {
      "type": "multiplier",
      "subType": 2,
      "duration": 900000
    }
  },
  {
    "id": "basic_0041",
    "requirement": 8225,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_1",
      "amount": 1
    }
  },
  {
    "id": "basic_0042",
    "requirement": 8725,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "amount": 1
    }
  },
  {
    "id": "basic_0043",
    "requirement": 8825,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "basic_0044",
    "requirement": 9025,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "duration": 1800000
    }
  },
  {
    "id": "basic_0045",
    "requirement": 9525,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_1",
      "amount": 1
    }
  },
  {
    "id": "basic_0046",
    "requirement": 10125,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "amount": 3
    }
  },
  {
    "id": "basic_0047",
    "requirement": 10225,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "basic_0048",
    "requirement": 10425,
    "reward": {
      "type": "powerups",
      "subType": "rocket",
      "duration": 900000
    }
  },
  {
    "id": "basic_0049",
    "requirement": 10925,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_3",
      "amount": 1
    }
  },
  {
    "id": "basic_0050",
    "requirement": 11025,
    "reward": {
      "type": "gems",
      "amount": 100
    }
  },
  {
    "id": "basic_0051",
    "requirement": 11225,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "basic_0052",
    "requirement": 11725,
    "reward": {
      "type": "powerups",
      "subType": "bomb",
      "duration": 900000
    }
  },
  {
    "id": "basic_0053",
    "requirement": 12325,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "amount": 3
    }
  },
  {
    "id": "basic_0054",
    "requirement": 12425,
    "reward": {
      "type": "multiplier",
      "subType": 2,
      "duration": 900000
    }
  },
  {
    "id": "basic_0055",
    "requirement": 12625,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_1",
      "amount": 1
    }
  },
  {
    "id": "basic_0056",
    "requirement": 13125,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "amount": 1
    }
  },
  {
    "id": "basic_0057",
    "requirement": 13225,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "basic_0058",
    "requirement": 13425,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "duration": 1800000
    }
  },
  {
    "id": "basic_0059",
    "requirement": 13925,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_1",
      "amount": 1
    }
  },
  {
    "id": "basic_0060",
    "requirement": 14525,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "amount": 3
    }
  }
]
